import { call, put, takeEvery, takeLatest } from 'redux-saga/effects'
import { handleApiErrors } from '../../lib/api-errors'
import axiosApi from '../../views/client/axiosClient'

import * as congNoConstant from './constants'
import * as congNoAction from './actions'

function handleRequest(request) {
  return request
    .then(handleApiErrors)
    .then(function (response) {
      return response.data;
    })
    .then(json => json)
    .catch((error) => { throw error })
}
function handleFileRequest(request) {
  return request
    .then(function (response) {
      return {
        data: response.data
      };
    })
    .catch((error) => { throw error })
}

function listRequestApi(formData) {
  const request = axiosApi().post(
    congNoConstant.CONGNO_NV_LIST_API,
    formData
  )

  return handleRequest(request);
}

function* congNoListRequestFlow(action) {
  try {
    // grab the client from our action
    const { formData } = action
    const results = yield call(listRequestApi, formData)

    // dispatch the action with our widgets!
    yield put(congNoAction.congNoListSuccess(results.data))

  } catch (error) {
    yield put(congNoAction.congNoListError(error))
  }
}
function exportXlsRequestApi(formData) {
  let url = congNoConstant.CONGNO_NV_EXPORT_XLS_API + "?Loai=" + formData.Loai + "&NhanVienId=" + formData.NhanVienId + "&TinhThanhId=" + formData.TinhThanhId
    + "&page=" + formData.page + "&per_page=" + formData.per_page;
  const request = axiosApi().get(
    url,
    {
      responseType: 'blob'
    }
  );

  return handleFileRequest(request);
}
function* reportExportXlsRequestFlow(action) {
  const { formData, callback } = action
  try {
    // grab the client from our action
    const results = yield call(exportXlsRequestApi, formData)
    // dispatch the action with our widgets!
    yield put(congNoAction.reportExportXlsSuccess(results.data))
    if (typeof callback == 'function') {
      yield call(callback, results.data);
    }
  } catch (error) {
    yield put(congNoAction.reportExportXlsError(error))
  }
}
function congNoDvhcRequestApi(formData) {
  const request = axiosApi().post(
    congNoConstant.CONGNO_NV_DVHC_LIST_API,
    formData
  )
  return handleRequest(request);
}
function* congNoDvhcListRequestFlow(action) {
  const { formData } = action
  try {
    // grab the client from our action
    const results = yield call(congNoDvhcRequestApi, formData)

    // dispatch the action with our widgets!
    yield put(congNoAction.congNoDvhcListSuccess(results.data))

  } catch (error) {
    yield put(congNoAction.congNoDvhcListError(error))
  }
}
function congNoNvkdRequestApi(formData) {
  const request = axiosApi().post(
    congNoConstant.CONGNO_NV_NVKD_LIST_API,
    formData
  )
  return handleRequest(request);
}
function* congNoNvkdListRequestFlow(action) {
  const { formData } = action
  try {
    // grab the client from our action
    const results = yield call(congNoNvkdRequestApi, formData)

    // dispatch the action with our widgets!
    yield put(congNoAction.congNoNvkdListSuccess(results.data))

  } catch (error) {
    yield put(congNoAction.congNoNvkdListError(error))
  }
}

function congNoNvUpdateRequestApi(formData) {
  const request = axiosApi().post(
    congNoConstant.CONGNO_NV_UPDATE_API,
    formData
  )
  return handleRequest(request);
}


function* congNoNvUpdateRequestFlow({ payload, callback }) {
  try {
    // grab the client from our action
    const response = yield call(congNoNvUpdateRequestApi, payload)
    if (response.code != 200) {
      return yield put(congNoAction.congNoNvUpdateError(response.message))
    }
    // dispatch the action with our widgets!
    yield put(congNoAction.congNoNvUpdateSuccess(response));
    if (typeof callback == 'function') {
      yield call(callback, {});
    }
  } catch (error) {
    yield put(congNoAction.congNoNvUpdateError(error))
  }
}

function* congNoNhanVienWatcher() {
  yield [
    takeEvery(congNoConstant.CONGNO_NV_LIST_REQUESTING, congNoListRequestFlow),
    takeEvery(congNoConstant.CONGNO_NV_EXPORT_XLS_REQUESTING, reportExportXlsRequestFlow),
    takeLatest(congNoConstant.CONGNO_NV_DVHC_LIST_REQUESTING, congNoDvhcListRequestFlow),
    takeLatest(congNoConstant.CONGNO_NV_NVKD_LIST_REQUESTING, congNoNvkdListRequestFlow),
    takeEvery(congNoConstant.CONGNO_NV_UPDATE_REQUESTING, congNoNvUpdateRequestFlow)
  ]
}

export default congNoNhanVienWatcher



// WEBPACK FOOTER //
// ./src/views/CongNoNhanVien/sagas.js